/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Owned_TitleInputs */

const cs_clients_owned_title = /** @type {(inputs: Clients_Owned_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastněné nabídky`)
};

const en_clients_owned_title = /** @type {(inputs: Clients_Owned_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owned listings`)
};

/**
* | output |
* | --- |
* | "Owned listings" |
*
* @param {Clients_Owned_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_owned_title = /** @type {((inputs?: Clients_Owned_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Owned_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_owned_title(inputs)
	return cs_clients_owned_title(inputs)
});